export { INTERACTION_EXPORT_FIELDS, EXPORT_FIELDS_CONFIG_VERSION, getFieldDefinition, getDefaultVisibleFields, getFieldsByCategory, } from "../config/exportFieldsConfig";
export const getDateRangeLabel = (startDate, endDate) => {
    const start = startDate.toLocaleDateString();
    const end = endDate.toLocaleDateString();
    if (start === end) {
        return start;
    }
    return `${start} - ${end}`;
};
export const createDatePreset = (preset) => {
    const now = new Date();
    let endDate;
    let startDate;
    switch (preset) {
        case "1d":
            endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
            startDate = new Date(endDate);
            startDate.setDate(startDate.getDate() - 1);
            break;
        case "7d":
            endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
            startDate = new Date(endDate);
            startDate.setDate(startDate.getDate() - 7);
            break;
        case "14d":
            endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
            startDate = new Date(endDate);
            startDate.setDate(startDate.getDate() - 14);
            break;
        case "30d":
            endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
            startDate = new Date(endDate);
            startDate.setDate(startDate.getDate() - 30);
            break;
        case "90d":
            endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
            startDate = new Date(endDate);
            startDate.setDate(startDate.getDate() - 90);
            break;
        case "ytd":
            endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
            startDate = new Date(now.getFullYear(), 0, 1);
            break;
        case "lastyear":
            endDate = new Date(now.getFullYear() - 1, 11, 31, 23, 59, 59);
            startDate = new Date(now.getFullYear() - 1, 0, 1);
            break;
        default:
            endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
            startDate = new Date(endDate);
            startDate.setDate(startDate.getDate() - 7);
    }
    return {
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        preset,
    };
};
//# sourceMappingURL=interactions.js.map